module.exports = __webpack_public_path__ + "img/garden.5dbf3849.png";